import { sortAlphaNumByKey } from './sortAlphaNum';
import { groupBy } from 'lodash';

export const manipulateExpecptionHierarchy = (execptionList: Array<any>, selectable: boolean, expanded: boolean, nodeClass?: string) => {
  execptionList = execptionList.map((row) => {
    return {
      ...row,
      parentID: row.parentID ? row.parentID : null,
    };
  });
  const grouped = groupBy(
    execptionList,
    (execption) => execption.parentID
  );
  function childrenOf(parentId: any): any {
    return (grouped[parentId] || []).map((execption) => {
      return {
        parentId: execption.parentID ? execption.parentID : null,
        label: execption.key ? `${execption.key} - ${execption.description}` : execption.description,
        data: execption.ehD_ID,
        key: execption.parentId ? `${execption.parentId}${execption.ehD_ID}`: `${execption.ehD_ID}`,
        icon: '',
        isRoot: execption.level == 1 ? true : false,
        leaf: execption.leaf ? true: false,
        expanded: expanded,
        partialSelected: false,
        styleClass: nodeClass,
        draggable: true,
        droppable: false,
        selectable: selectable,
        level: execption.level,
        children: childrenOf(execption.ehD_ID),
        metaData: execption,
        name: execption.description
      }
    })
  }
  function alphabeticSort(execptionList:any){
    if(execptionList["children"] && execptionList["children"].length > 0){
      execptionList["children"].forEach ((child: any) => alphabeticSort(child));
      execptionList.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'));
      return execptionList;
    }
  }
  execptionList = childrenOf(null);
  execptionList.forEach ((child: any) => alphabeticSort(child));
  return execptionList;
}
